import {getTranslation} from './translations';

/* eslint-disable no-undef */
const ref = typeof Vue !== 'undefined' ? Vue.ref : null;
const watch = typeof Vue !== 'undefined' ? Vue.watch : null;

const template = `
	<div class="ubf-dynamicList__sortSelect">
		<label for="dlc_sort" class="ubf-dynamicList__sortSelectLabel ubf-field__label">{{trans('sort')}}</label>
		<div class="ubf-field__inputWrapper">
			<select class="ubf-dynamicList__select ubf-field__input ubf-field__input--select" id="dlc_sort" :value="localSortField" @input="onInput" @change="onChange">
				<option key="title" value="title ASC">{{trans('Title')}} ({{trans('asc')}}.)</option>
				<option key="title" value="title DESC">{{trans('Title')}} ({{trans('desc')}}.)</option>
				<template v-for="field in fields">
					<option :key="field.id" :value="field.id + ' ASC'">{{ field.title }} ({{trans('asc')}}.)</option>
					<option :key="field.id" :value="field.id + ' DESC'">{{ field.title }} ({{trans('desc')}}.)</option>
				</template>
			</select>
			<span class="ubf-field__selectIcon"><span data-type="svg">
				<canvas width="17" height="22"></canvas><svg viewBox="0 0 17 22" focusable="false" aria-hidden="true"><use xlink:href="#triangle-right"></use></svg>
			</span></span>
		</div>
	</div>
`;

export default {
	emits: ['change'],
	template: template,
	props: {
		fields: Array,
		sortField: String
	},
	setup: function (props, context) {
		const localSortField = ref(props.sortField);
		watch(
			() => props.sortField, (newField) => {localSortField.value = newField;}
		);
		return {
			trans: getTranslation,
			localSortField: localSortField,
			fields: props.fields,
			sortField: props.sortField,
		};
	},

	methods: {
		onChange: function(event) {
			this.$emit('change', event.target.value);
		},
	},
};

